export default __webpack_public_path__ + "static/phone-e6b404d2ab3898cf46f55a454557af66.png";